// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13_t1","col":"styles_col__3WFrt"};